<div (click)="pickerOpen = !pickerOpen" class="picker-btn">
  <span  [style.background-color]="selectedColor"   class="chevron"></span>
  <ul *ngIf="pickerOpen">
    <li *ngFor="let color of _colors" [style.background-color]="color.value" (click)="onSelect(color)"></li>
  </ul>
</div>

